import type { KombiDataState } from '../viewModels';

export interface HttpStatus {
  status: number;
  ok: boolean;
}

/** Normalise HTTP semantics once, retaining Trailblazer's feature-dependent 404 distinction. */
export function kombiStateFromHttp<T>(
  response: HttpStatus,
  value: T | null,
  options: { featureDependent404?: boolean } = {},
): KombiDataState<T> {
  if (response.status === 401) return { kind: 'signed-out' };
  if (response.status === 403) return { kind: 'forbidden' };
  if (response.status === 404 && options.featureDependent404) return { kind: 'unavailable' };
  if (!response.ok) return { kind: 'error', status: response.status };
  if (value === null) return { kind: 'empty' };
  return { kind: 'ready', value };
}
